import { Radio, RadioChangeEvent, Typography } from "antd";
import React, { memo, useCallback } from "react";
import { BreakdownMode } from "../api";
import styles from "./BaseRentBreakdownModeToggle.module.scss";

const { Text } = Typography;

type BaseRentBreakdownModeToggleProps = {
  value: BreakdownMode;
  onChange: (value: BreakdownMode) => void;
};

export const BaseRentBreakdownModeToggle = memo((props: BaseRentBreakdownModeToggleProps) => {
  const { value, onChange } = props;

  const handleChange = useCallback(
    (e: RadioChangeEvent) => {
      onChange(e.target.value as BreakdownMode);
    },
    [onChange],
  );

  return (
    <div className={styles.root}>
      <Text className={styles.label}>View as</Text>
      <Radio.Group className={styles.group} value={value} onChange={handleChange} buttonStyle="solid">
        <Radio.Button value="billingSchedule">Billing Line</Radio.Button>
        <Radio.Button value="paymentSchedule">Schedule</Radio.Button>
      </Radio.Group>
    </div>
  );
});
